export default __webpack_public_path__ + "static/media/FinishedIcon.a79944f9.svg";